import axios from 'axios';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { persist } from 'mobx-persist';
import { ExecutionsAPI } from '~/services/api';
import RootStore from './index';

export default class FormStore {
  @observable
  root: typeof RootStore;

  @persist('object')
  @observable
  table: ExecutionsType.ExecutionsResponseAPI[] | [] = [];

  @persist('object')
  @observable
  testData: ExecutionsType.TestDataResponseAPI[] | [] = [];

  constructor(root: typeof RootStore) {
    this.root = root;
    makeObservable(this);
  }

  @action
  create = async ({ quantity = 1, ...fields }: ExecutionsType.CreateParams) => {
    try {
      const apiMethod = this.root.process.processSelected.external
        ? ExecutionsAPI.schedule
        : ExecutionsAPI.run;
      await apiMethod({
        repository_name: this.root.process.processSelected.repository_name,
        quantity,
        processUid: this.root.process.processSelected.name,
        subProcessUid: this.root.process.sub_process.name,
        custom_fields: fields,
//        group: this.root.process.client,
      });
      this.listAll();
    } catch (error) {
      console.error('Error in create execution:', error);
    }
  };

  @action
  consumeTestData = async (qtd_data: number, id_test_data: string): Promise<void> => {
    try {
      await ExecutionsAPI.consumeTestData(qtd_data, id_test_data);
      this.listAllTestData();
    } catch (error) {
      console.error('Error in consume test data:', error);
    }
  };

  @action
  listAll = async (): Promise<void> => {
    try {
      this.table = [];
      const data = await ExecutionsAPI.listAll();
      runInAction(() => {
        this.table = data.reverse();
      });
    } catch (error) {
      console.error('Error listing executions:', error);
    }
  };

  @action
  listAllTestData = async (): Promise<void> => {
    try {
      this.testData = [];
      const data = await ExecutionsAPI.listAllTestData();
      runInAction(() => {
        this.testData = data;
      });
    } catch (error) {
      console.error('Error listing test data:', error);
    }
  };

  @action
  onDownload = async (id: string) => {
    try {
      await ExecutionsAPI.download(id);
    } catch (error) {
      console.error('Error downloading execution file:', error);
    }
  };
}